import { Modal } from "react-bootstrap";

const CommonModal = ({
  show,
  onHide,
  children,
  title = null,
  footer = null,
  modalProps: { className: modalClassName, ...modalProps },
  modalHeaderProps,
  modalBodyProps,
  modalFooterProps,
}) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      className={modalClassName}
      {...modalProps}
    >
      {title && <Modal.Header {...modalHeaderProps}>{title}</Modal.Header>}
      <Modal.Body {...modalBodyProps}>{children}</Modal.Body>
      {footer && <Modal.Footer {...modalFooterProps}>{footer}</Modal.Footer>}
    </Modal>
  );
};

export default CommonModal;
